import * as React from "react";
import classnames from "classnames";
import { Text } from "@grandvisionhq/elements";
import { Icon } from "@grandvisionhq/icons";
/* empty css                */
const TileLayout = ({
  title,
  subtitle,
  aside,
  iconName,
  className,
  children
}) => {
  return /* @__PURE__ */ React.createElement("div", { className: classnames("tile-layout", className) }, iconName && /* @__PURE__ */ React.createElement("div", { className: "tile-layout__aside tile-layout__aside--icon" }, /* @__PURE__ */ React.createElement(Icon, { name: iconName, className: "tile-layout__icon" })), /* @__PURE__ */ React.createElement("div", { className: "tile-layout__main" }, /* @__PURE__ */ React.createElement(Text, { className: "tile-layout__title", variant: "caption-head" }, title), subtitle && /* @__PURE__ */ React.createElement(Text, { className: "tile-layout__subtitle", variant: "caption" }, subtitle), children), aside && /* @__PURE__ */ React.createElement("div", { className: "tile-layout__aside" }, aside));
};
export {
  TileLayout
};
//# sourceMappingURL=TileLayout.js.map
